import { useEffect, useState } from 'react';

/** Tunes WebGL shader cost vs sharpness for mobile / tablet / desktop. */
export function useShaderViewportQuality() {
  const [quality, setQuality] = useState({
    minPixelRatio: 2 as number,
    maxPixelCount: 8_294_400,
  });

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 640) {
        setQuality({ minPixelRatio: 1.25, maxPixelCount: 1_600_000 });
      } else if (w < 1024) {
        setQuality({ minPixelRatio: 1.5, maxPixelCount: 3_600_000 });
      } else {
        setQuality({ minPixelRatio: 2, maxPixelCount: 8_294_400 });
      }
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return quality;
}
